import AxiosInstance from 'src/shared/services/axios/interceptor';

// Autogiro för månadsgivare. Egna adresser i stället för MemberAutogiro, eftersom uppdragen är av
// typen gift_recurring och API:t vägrar köra fel variant mot fel uppdrag.
const controller = 'DonorAutogiro';

export type AutogiroFileStatus = {
  hasFile: boolean;
  sent: boolean;
};

export type AutogiroValidation = {
  isValid: boolean;
  lines: string[];
};

export const getDonorAutogiroFileStatus = (missionId: number) => {
  return AxiosInstance.get<AutogiroFileStatus>(`${controller}/FileStatus?missionId=${missionId}`, {
    skipErrorToast: true,
  });
};

export const createDonorAutogiroFile = (missionId: number) => {
  return AxiosInstance.put<{ fileName: string }>(`${controller}/CreateFile?missionId=${missionId}`, null, { timeout: 180000 });
};

export const validateDonorAutogiroFile = (missionId: number) => {
  return AxiosInstance.get<AutogiroValidation>(`${controller}/ValidateFile?missionId=${missionId}`, {
    timeout: 180000,
    skipErrorToast: true,
  });
};

// Svarar 400 med { message, lines } när kontrollen hittar fel, och då skickas ingenting. Anroparen
// visar raderna, så skipErrorToast för att felet inte ska dyka upp som en nakna toast också.
export const sendDonorAutogiroFile = (missionId: number) => {
  return AxiosInstance.put<{ sent: boolean; message?: string }>(`${controller}/SendFile?missionId=${missionId}`, null, {
    timeout: 180000,
    skipErrorToast: true,
  });
};

export const undoDonorAutogiroInvoices = (missionId: number) => {
  return AxiosInstance.put(`${controller}/UndoCreateInvoices?missionId=${missionId}`, null, {
    timeout: 180000,
    skipErrorToast: true,
  });
};
